export const menuList = [
    {
        title: 'Компания',
        href: '/#about',
    },
    {
        title: 'Услуги',
        href: '/#services',
    },
    {
        title: 'Контакты',
        href: '/#footerContacts',
    },
] as const;
